var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":_vm.pathDescription,"fill":"none","stroke":_vm.conversion.bAB === true ? '#1199af' : '#9fce12',"stroke-width":_vm.strokeWidth,"stroke-dasharray":_vm.strokeWidth === 1 ? '3,2' : ''}})}
var staticRenderFns = []

export { render, staticRenderFns }